import React from "react";
import { Box, Stack, Typography } from "@mui/material";

export default function PersonFocusCard({ person }) {
  const goal = person?.shared_goal_summary || null;
  const focusArea = person?.focus_area ? `Working on ${String(person.focus_area).toLowerCase()}` : "";
  const supporting = person?.shared_focus_statement || person?.headline || goal?.summary || "";
  const emptyText = person?.sprint_id
    ? "Accountability details are private right now."
    : "This person is keeping their plan private until Accountability starts.";

  return (
    <Box
      sx={{
        borderRadius: 4,
        border: "1px solid rgba(224, 231, 240, 0.92)",
        bgcolor: "#fff",
        boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
        p: { xs: 2, md: 2.4 },
      }}
    >
      <Stack spacing={1.8}>
        <Typography variant="h6" sx={{ fontWeight: 800, color: "#16213f" }}>
          Current focus
        </Typography>
        {goal || focusArea || supporting ? (
          <>
            <Stack spacing={1}>
              {focusArea ? (
                <Typography variant="overline" sx={{ color: "#7b8794", fontWeight: 800 }}>
                  {focusArea}
                </Typography>
              ) : null}
              {goal?.title ? (
                <Typography variant="h5" sx={{ fontSize: 26, fontWeight: 800, color: "#13233c" }}>
                  {goal.title}
                </Typography>
              ) : null}
              {supporting ? (
                <Typography variant="body2" sx={{ color: "#70839a", maxWidth: 540 }}>
                  {supporting}
                </Typography>
              ) : null}
            </Stack>
          </>
        ) : (
          <Typography variant="body2" sx={{ color: "#70839a" }}>
            {emptyText}
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
